module.exports = __webpack_public_path__ + "img/icon-warning-extreme.cb29f101.svg";